module.exports = __webpack_public_path__ + "img/play-component-icon.a8045f8f.svg";